import { useFullScreenLoadingContext } from '@aibees/shared/context';
import { classnames } from '@aibees/shared/utils';
import { Backdrop, CircularProgress, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import * as SX from './sx';
import type { FullScreenLoadingProps as Props } from './types';

export const FullScreenLoading = memo(({ className }: Props) => {
  const { state: loadingScreenState, title } = useFullScreenLoadingContext();

  if (!loadingScreenState.value) return null;

  return (
    <Backdrop
      className={classnames('FullScreenLoading', className)}
      sx={SX.root}
      open={true}
    >
      <Stack direction="row" alignItems="center" gap={1}>
        <CircularProgress size={30} color="inherit" />
        <Typography variant="body2">{title}</Typography>
      </Stack>
    </Backdrop>
  );
});

FullScreenLoading.displayName = 'FullScreenLoading';
